import BaseApiService from './BaseApiService'

export interface Webhook {
  webhookId: string
  url: string
  description: string | null
  isActive: boolean
  lastTriggeredAt: string | null
  createdAt: string
  secretHint: string
}

export interface WebhookCreated extends Webhook {
  secret: string
}

class WebhooksApiService extends BaseApiService {
  list(): Promise<Webhook[]> {
    return this.get('/v1/webhooks')
  }

  create(url: string, description?: string): Promise<WebhookCreated> {
    return this.post('/v1/webhooks', { url, description: description || null })
  }

  delete(webhookId: string): Promise<void> {
    return this.request('DELETE', `/v1/webhooks/${webhookId}`)
  }
}

export const webhooksApiService = new WebhooksApiService()
